<template>
	<div>
		<template v-if="step === 1">
			<h3>
				<span class="color-primary">{{ customerName }}</span> von
				<span class="color-primary">{{ companyName }}</span> hat dir einen Terminvorschlag zur Position
				<span class="color-primary">{{ jobProfileInfo }}</span> gesendet.
			</h3>
			<div v-if="appointment">
				<AppointmentInfos
					:appointment="appointment"
					type="applicant"
				/>
				<DateChoiceOrProposal
					v-model="dateChoiceOrProposalData"
					:appointment="appointment"
					type="applicant"
				/>
			</div>
			<PopUpActions
				:with-back="false"
				continue-text="Weiter"
				:continue-disabled="!dateChoiceOrProposalDataValid"
				@continue="step = 2"
			/>
		</template>
		<template v-if="step === 2">
			<template v-if="dateChoiceOrProposalData.datesNotPossible || dateChoiceOrProposalData.allDatesPastDue">
				<template v-if="isCounterProposalTypeSuggestions">
					<JonInfo
						v-if="dateChoiceOrProposalData.counterProposalDates.length > 0"
						class="mt-0 mb-2"
					>
						<template #message>
							<div>Bitte überprüfe deine vorgeschlagenen Termine auf Korrektheit:</div>
						</template>
					</JonInfo>
					<div
						v-for="date in dateChoiceOrProposalData.counterProposalDates"
						:key="date.id"
						:class="['font-weight-bold']"
					>
						{{ date | fullDateTimeByDateAndTime }}
					</div>
				</template>
				<div v-else>Der Kunde wird informiert dass er dir neue Terminvorschläge schicken soll.</div>
			</template>
			<template v-else>
				<h3>{{ dateChoiceOrProposalData.chosenDate.timeStamp | fullDateTime }} bestätigen</h3>
				<JonInfo class="mt-3">
					<template #message>
						Du erhältst noch rechtzeitig allfällige Details, die du vor dem Termin benötigst.<br/>
						Wenn du "Termin bestätigen" drückst, erhält
						<span class="font-weight-extra-bold color-primary">{{ customerName }}</span> eine Nachricht,
						dass du den Termin angenommen hast.<br/>
						Alle Termine findest du im Bereich "Deine Job-Termine", welche dort auch bearbeitet werden können.
					</template>
				</JonInfo>
			</template>
			<div class="mt-3">
				<PopUpActions
					:continue-text="step2ContinueText"
					:continue-disabled="sendingRequest"
					:continue-loading="sendingRequest"
					@back="step = 1"
					@continue="continueOnStep2"
				/>
			</div>
		</template>
		<!--<template v-if="step === 3">
			<template v-if="dateChoiceOrProposalData.datesNotPossible">
				<div v-if="isCounterProposalTypeSuggestions">
					<span class="font-weight-extra-bold">{{ customerName }}</span> von
					<span class="font-weight-extra-bold">{{ companyName }}</span> wird informiert, dass für dich keiner der
					angegebenen Termine möglich ist. Deine Terminvorschläge werden übermittelt.
				</div>
				<div v-else>
					<span class="font-weight-extra-bold">{{ customerName }}</span> von
					<span class="font-weight-extra-bold">{{ companyName }}</span> wird informiert, dass für dich keiner der
					angegebenen Termine möglich ist und dir neue Termine vorgeschlagen werden sollen.
				</div>
			</template>
			<template v-else>
				<JonInfo>
					<template #message>
						Der Termin mit <b>{{ customerName }}</b>
						<span v-if="companyName"> von <b>{{ companyName }}</b></span> findet am
						{{ dateChoiceOrProposalData.chosenDate.timeStamp | fullDateTime }} statt.
						<b>{{ customerName }}</b> und du erhalten per E-Mail eine entsprechende Nachricht!
					</template>
				</JonInfo>
			</template>
			<PopUpActions
				:with-back="false"
				continue-text="OK"
				@continue="$emit('processed')"
			/>
		</template>-->
	</div>
</template>
<script>
import DateChoiceOrProposal from "@/vue/communication/conversation/message/reply/DateChoiceOrProposal";
import {isDefined} from "@/helper/Value";
import PopUpActions from "@/vue/common/popup/PopUpActions";
import Reply, {ACTION_CONFIRM_APPOINTMENT, ACTION_APPOINTMENT_DATES_NOT_POSSIBLE} from "@/api/communication/conversation/message/Reply";
import _ from "lodash";
import AppointmentInfos from "@/vue/communication/conversation/message/reply/AppointmentInfos";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import JonInfo from "@/vue/common/JonInfo.vue";

const COUNTER_PROPOSAL_TYPE_SUGGESTIONS = 'suggestions';

export default {

	components: {
		JonInfo,
		DateChoiceOrProposal,
		PopUpActions,
		AppointmentInfos,
	},

	props: {
		message: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		return {
			step: 1,
			sendingRequest: false,
			dateChoiceOrProposalData: undefined,
		};
	},

	computed: {
		customerName ()
		{
			return this.message.customer.nameWithSalutation;
		},
		companyName ()
		{
			return this.message.customer.companyName;
		},
		jobProfileInfo ()
		{
			return this.message.jobProfile.info;
		},
		appointment ()
		{
			return this.message.appointment;
		},
		isCounterProposalTypeSuggestions ()
		{
			return this.dateChoiceOrProposalData?.counterProposalType === COUNTER_PROPOSAL_TYPE_SUGGESTIONS;
		},
		dateChoiceOrProposalDataValid ()
		{
			return isDefined(this.dateChoiceOrProposalData);
		},
		step2ContinueText ()
		{
			if (this.dateChoiceOrProposalData?.datesNotPossible)
			{
				return this.isCounterProposalTypeSuggestions
					? 'Terminvorschläge senden'
					: 'Bestätigen';
			}

			return 'Termin bestätigen';
		}
	},

	methods: {
		continueOnStep2 ()
		{
			if (this.dateChoiceOrProposalData.datesNotPossible || this.dateChoiceOrProposalData.allDatesPastDue)
			{
				this.sendCounterProposal();

				return;
			}

			this.confirmAppointment();
		},
		async confirmAppointment ()
		{
			this.sendingRequest = true;

			try
			{
				await new Reply()
					.setMessageId(this.message.id)
					.setAction(ACTION_CONFIRM_APPOINTMENT)
					.setChosenDate(this.dateChoiceOrProposalData.chosenDate.id)
					.call();

				this.$emit('processed');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.sendingRequest = false;
		},
		async sendCounterProposal ()
		{
			this.sendingRequest = true;

			try
			{
				let counterProposalDates = [];

				if (this.isCounterProposalTypeSuggestions)
				{
					counterProposalDates = _.map(
						this.dateChoiceOrProposalData.counterProposalDates,
						date => _.pick(date, [ 'date', 'time' ])
					);
				}

				await new Reply()
					.setMessageId(this.message.id)
					.setAction(ACTION_APPOINTMENT_DATES_NOT_POSSIBLE)
					.setCounterProposalDates(counterProposalDates)
					.call();

				this.$emit('processed');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.sendingRequest = false;
		}
	}
}
</script>
